import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=5b68d79e&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=5b68d79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68d79e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b68d79e')) {
      api.createRecord('5b68d79e', component.options)
    } else {
      api.reload('5b68d79e', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=5b68d79e&scoped=true&", function () {
      api.rerender('5b68d79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenders/Edit.vue"
export default component.exports